<template>
    <div class="row footer">
        <div class="col-md-4 text-center">
            <img src="../assets/img/bonjour-logo.svg" width="150px" />

        </div>
        <div class="col-md-4" style="padding-top:10px;padding-bottom:10px;">
            <div class="footer-address" style="line-height: 25px;">
                <font-awesome-icon icon="map-marker-alt" /> &nbsp; Austin, TX<br> <font-awesome-icon icon="phone" /> &nbsp;(512) 574-4422
                <br><a class="mid-links" href="mailto:info@bonjourbrigadeiro.com"><font-awesome-icon icon="envelope" /> &nbsp; info@bonjourbrigadeiro.com</a>
                <br><a class="mid-links" href="http://www.bonjourbrigadeiro.com"><font-awesome-icon icon="globe-americas" /> &nbsp; www.bonjourbrigadeiro.com</a>
            </div>
        </div>
        <div class="col-md-4 text-center">
            <a href="https://www.facebook.com/bonjourbrigadeirotx" target="_blank"><img src="../assets/img/facebook.svg" class="img-reponsive" width="75px" /></a>
            <a href="https://www.instagram.com/bonjourbrigadeiro/" target="_blank"><img src="../assets/img/instagram.svg" class="img-reponsive" width="75px" /></a>
        </div>
    </div>
</template>
<script>
export default {
    name: "BonjourFooter"
}
</script>
<style lang="scss">
.footer {
    background-color: #300B02;
    padding-top: 20px;
    color: #F8E1EA !important;
    margin-left: 0px !important;
    margin-right: 0px !important;
    margin-top: 100px;
    padding-top: 50px;
    padding-bottom: 50px;
    .mid-links {
        color: #F8E1EA !important;
        &:hover {
            color: #F8E1EA !important;
        }
    }
}

div.footer-address {
    line-height: 30px;
    margin-left: 55px;
}
</style>